module.exports = __webpack_public_path__ + "img/B高通10.869fd3db.png";